import axios from "axios";
import { appConstants, stringConstants } from "../helpers/app-constants";
import { BHAREE_BASE_URL_LOCAL } from "../config/config.url";
import isEmpty from "../utils/is-Empty";
import { toast } from "react-toastify";
import { getApiDetails } from "./apiDetails";

let options = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${localStorage.jwtToken}`,
  },
};

export const getCurrentVehicleLoad = async (
  dispatch,
  logisticPartnerId,
  logisticVehicleId = null,
) => {
  let details = getApiDetails["getCurrentVehicleLoad"];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    const mUrl = BHAREE_BASE_URL_LOCAL + details.route;

    let postData = { logistic_partner_id: logisticPartnerId };
    if (logisticVehicleId) {
      postData.logistic_vehicle_id = logisticVehicleId;
    }

    res = await axios.post(mUrl, postData, options);
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

export const getGuestJWTToken = async (dispatch, captchaToken) => {
  let details = getApiDetails["getGuestJWTToken"];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    const mUrl = BHAREE_BASE_URL_LOCAL + details.route;

    res = await axios.post(
      mUrl,
      {
        captchaToken: captchaToken,
      },
      {
        headers: {
          ...details.headers,
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "x-guest-token": `${localStorage.guest_jwt_token}`,
        },
      },
    );
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rolesloading: false,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

export const renewGuestJWTToken = async (dispatch) => {
  let details = getApiDetails["renewGuestJWTToken"];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    const mUrl = BHAREE_BASE_URL_LOCAL + details.route;

    res = await axios.get(mUrl, {
      headers: {
        ...details.headers,
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "x-guest-token": `${localStorage.guest_jwt_token}`,
      },
    });
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rolesloading: false,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

export const getDealOfTheDay = async (dispatch, district = "") => {
  let details = getApiDetails["getDealOfTheDay"];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    const mUrl = !isEmpty(district)
      ? BHAREE_BASE_URL_LOCAL + details.route + "?district=" + district
      : BHAREE_BASE_URL_LOCAL + details.route;

    res = await axios.get(mUrl, {
      headers: {
        ...details.headers,
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "x-guest-token": `${localStorage.guest_jwt_token}`,
      },
    });
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rolesloading: false,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

export const getProductDetailsAPI = async (dispatch, id = "", district = "") => {
  let details = getApiDetails["getProductDetails"];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    const mUrl = !isEmpty(district)
      ? `${BHAREE_BASE_URL_LOCAL}${details.route}/${!isEmpty(id) ? id : ""}?district=${district}`
      : `${BHAREE_BASE_URL_LOCAL}${details.route}/${!isEmpty(id) ? id : ""}`;

    res = await axios.get(mUrl, {
      headers: {
        ...details.headers,
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "x-guest-token": `${localStorage.guest_jwt_token}`,
      },
    });
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rolesloading: false,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

// common get api funtion
export const getApi = async (apiName, dispatch, id = "") => {
  let details = await getApiDetails[apiName];
  let res = {};
  await dispatch({
    type: details.loding,
  });
  try {
    res = await axios.get(BHAREE_BASE_URL_LOCAL + details.route + (!isEmpty(id) ? id : ""), {
      headers: {
        ...details.headers,
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "x-guest-token": `${localStorage.guest_jwt_token}`,
      },
    });
    return res.status === 200
      ? dispatch({
          type: details.success,
          payload: res?.data?.data,
          rolesloading: false,
          rawData: res?.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: details.error,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at${details.route}`,
    );
  }
};

//custom get api function
export const getProductsList = async (dispatch, filter = {}, skip = 0, limit = 10000) => {
  let filterString = "";
  let res = {};

  // console.log("Inside GetProductList: ", filter);

  Object.entries(filter).map(([key, value]) => {
    if (!isEmpty(value) && typeof value !== "object") {
      let id = value.split("|")[1];
      if (!isEmpty(id)) {
        filterString = filterString + "&" + key + "=" + id;
      } else {
        filterString = filterString + "&" + key + "=" + value;
      }
    }
    return filterString;
  });

  console.log("FilterString: ", filterString);

  await dispatch({
    type: appConstants.LOADING_PRODUCTS_LIST,
  });

  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL +
        `/api/productlist?limit=${limit}&skip=${skip}${filterString}${
          !isEmpty(filter?.sort) ? "&sort=" + filter?.sort?.value : ""
        }`,
      {
        headers: {
          ...options.headers,
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "x-guest-token": `${localStorage.guest_jwt_token}`,
        },
      },
    );
    return dispatch({
      type: appConstants.GET_PRODUCTS_LIST,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_PRODUCTS_LIST,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at productlist`,
    );
  }
};

export const getCartAtLogin = async (dispatch, token = localStorage.jwtToken) => {
  await dispatch({
    type: appConstants.LOADING_CART,
  });
  let res = {};
  try {
    res = await axios.get(BHAREE_BASE_URL_LOCAL + "/cart", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
      },
    });
    return dispatch({
      type: appConstants.GET_CART,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_CART,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at cart at login`,
    );
  }
};

export const getLiveOfferMonthCount = async (dispatch) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_LIVE_OFFERS_COUNT,
  });
  try {
    res = await axios.get(BHAREE_BASE_URL_LOCAL + `/api/getLiveOfferMonthCount`, options);
    return dispatch({
      type: appConstants.GET_LIVE_OFFERS_COUNT,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_LIVE_OFFERS_COUNT,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at getLiveOfferMonthCount`,
    );
  }
};

export const markNotificationsAsRead = async (dispatch) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_MARK_NOTIFICATIONS,
  });
  try {
    res = await axios.get(BHAREE_BASE_URL_LOCAL + `/notifications/markRead`, options);
    return dispatch({
      type: appConstants.GET_MARK_NOTIFICATIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_MARK_NOTIFICATIONS,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at markNotificationsAsRead`,
    );
  }
};

export const markSingleNotificationsAsRead = async (dispatch, id) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_MARK_NOTIFICATIONS,
  });
  try {
    res = await axios.get(BHAREE_BASE_URL_LOCAL + `/notifications/markRead/${id}`, options);
    return dispatch({
      type: appConstants.GET_MARK_NOTIFICATIONS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_MARK_NOTIFICATIONS,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at markSingleNotificationsAsRead`,
    );
  }
};

export const getInvoices = async (dispatch, fromDate, toDate) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_INVOICES,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL + `/api/getInvoices?fromDate=${fromDate}&toDate=${toDate}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_INVOICES,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_INVOICES,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at invoices`,
    );
  }
};

export const getReportOrders = async (dispatch, fromDate, toDate) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_ORDERS,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL + `/orders?fromDate=${fromDate}&toDate=${toDate}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_ORDERS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_ORDERS,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at invoices`,
    );
  }
};

export const getReportEnquiries = async (dispatch, fromDate, toDate) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_ENQUIRY,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL + `/enquiry?fromDate=${fromDate}&toDate=${toDate}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_ENQUIRY,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_ENQUIRY,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at invoices`,
    );
  }
};

export const getCityAreas = async (dispatch, city = "") => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_CITY_AREAS,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL + `/api/getCityAreas${!isEmpty(city) ? "?city=" + city : ""}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_CITY_AREAS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_CITY_AREAS,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at city areas`,
    );
  }
};

export const getPinCodes = async (dispatch, city = "") => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_PIN_CODES,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL + `/api/getPinCodes${!isEmpty(city) ? "?city=" + city : ""}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_PIN_CODES,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_PIN_CODES,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at pincodes`,
    );
  }
};

export const getPinCodeAreas = async (dispatch, pincode = "") => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_PINCODE_AREAS,
  });
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL +
        `/api/getPinCodeAreas${!isEmpty(pincode) ? "?pincode=" + pincode : ""}`,
      options,
    );
    return dispatch({
      type: appConstants.GET_PINCODE_AREASS,
      payload: res.data.data,
    });
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_PINCODE_AREAS,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `server not responding at pincode areas`,
    );
  }
};

export const getGeoData = async (dispatch, countryCode = "", stateCode = "") => {
  let res = {};
  try {
    res = await axios.get(
      BHAREE_BASE_URL_LOCAL +
        `/api/geoData${!isEmpty(countryCode) ? "?countryCode=" + countryCode : ""}${
          !isEmpty(countryCode) && !isEmpty(stateCode) ? "&stateCode=" + stateCode : ""
        }`,
      options,
    );
    if (res.status === 200) {
      if (!isEmpty(countryCode) && !isEmpty(stateCode)) {
        return dispatch({
          type: appConstants.GET_CITIES,
          payload: res.data.data,
        });
      } else if (!isEmpty(countryCode) && isEmpty(stateCode)) {
        return dispatch({
          type: appConstants.GET_STATES,
          payload: res.data.data,
        });
      } else {
        return dispatch({
          type: appConstants.GET_COUNTRIES,
          payload: res.data.data,
        });
      }
    }
  } catch (err) {
    if (!isEmpty(countryCode) && !isEmpty(stateCode)) {
      dispatch({
        type: appConstants.ERRORS_CITIES,
        payload: err.response,
      });
      return toast.error(
        err.hasOwnProperty("response")
          ? err?.response?.data?.message
          : `sever not responding at country`,
      );
    } else if (!isEmpty(countryCode) && isEmpty(stateCode)) {
      dispatch({
        type: appConstants.ERRORS_STATES,
        payload: err.response,
      });
      return toast.error(
        err.hasOwnProperty("response")
          ? err?.response?.data?.message
          : `sever not responding at states`,
      );
    } else {
      dispatch({
        type: appConstants.ERRORS_COUNTRIES,
        payload: err.response,
      });
      return toast.error(
        err.hasOwnProperty("response")
          ? err?.response?.data?.message
          : `sever not responding at cities`,
      );
    }
  }
};

export const postVariant = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/variants", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
      return err;
    });
};

export const postMoq = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/moqs", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const patchProductCategories = (id, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + "/productcategory/" + id, userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const postProductCategories = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/productcategory", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const postPackagingTypes = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/packagingtype", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const postDeliveryType = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/deliverytype", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const postPaymentTypes = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/paymenttype", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};
export const postShelfLife = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/shelflife", userData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBhreeAdminBasicTables", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

export const postBrand = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/brands", userData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBrands", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

///post product
export const postProduct = (productData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/products", productData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getProducts", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

export const postProductVariant = (variantData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/products/variants", variantData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getProducts", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

export const postSaveServiceTaxDetails = (productData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/admin/saveServiceTaxDetails", productData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getServiceTaxDetails", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postProductStatus = (productData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/admin/updateProductStatus", productData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getProducts", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};
export const postBrandStatus = (productData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/admin/updateBrandStatus", productData, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBrands", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};
export const postAddresses = (address, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/users/addAddress", address, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken}`,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      // dispatch({
      //   type: appConstants.GET_ADDRESSES,
      //   payload: res.data.data,
      // });
      getApi("getAddressess", dispatch);
      return res.data;
      // set current user data
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postFactoryInfo = (factoryInfoData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/users/updateFactoryInfo", factoryInfoData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getFactoryInfo", dispatch);
      return res.data;
      // set current user data
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postBankInfo = (factoryInfoData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/users/updateBankInfo", factoryInfoData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBankInfo", dispatch);
      return res.data;
      // set current user data
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postLiveOffer = async (data, dispatch) => {
  let res = {};
  await dispatch({
    type: appConstants.REQUEST_CALL,
  });
  try {
    res = await axios.post(BHAREE_BASE_URL_LOCAL + "/liveoffers", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    });

    console.log("postLiveOffer: ", res);

    if (res.status === 200) {
      if (res.data.success) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
      getApi("getLiveOffer", dispatch);
      getApi("getLiveOfferProductsList", dispatch);
      return dispatch({
        type: appConstants.REQUEST_COMPLETED,
        data: res.data,
      });
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at postLiveOffer`,
    );
  }

  return res;
};

export const postEnquiry = async (data, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  return axios
    .post(BHAREE_BASE_URL_LOCAL + "/enquiry", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postCart = async (data, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  return axios
    .post(BHAREE_BASE_URL_LOCAL + "/cart", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getCart", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const postSupport = async (data, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  return axios
    .post(BHAREE_BASE_URL_LOCAL + "/support", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "x-guest-token": `${localStorage.guest_jwt_token}`,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      // window.location.href = "/support";
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const createSubscription = async (data, dispatch) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_CREATE_SUBSCRIPTION,
  });
  try {
    res = await axios.post(BHAREE_BASE_URL_LOCAL + "/api/createSubscription", data, options);
    return res.status === 200
      ? dispatch({
          type: appConstants.CREATE_SUBSCRIPTION,
          data: res.data.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at createSubscription`,
    );
  }
};

export const subscriptionSuccess = async (data, dispatch) => {
  let res = {};
  await dispatch({
    type: appConstants.REQUEST_CALL,
  });
  try {
    res = await axios.post(BHAREE_BASE_URL_LOCAL + "/api/subscriptionSuccess", data, options);
    return res.status === 200
      ? dispatch({
          type: appConstants.REQUEST_COMPLETED,
          data: res.data,
        })
      : "";
  } catch (err) {
    dispatch({
      type: appConstants.REQUEST_FAIL,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at subscriptionSuccess`,
    );
  }
};

export const postOrder = async (data, dispatch, navigate) => {
  let res = {};
  await dispatch({
    type: appConstants.LOADING_PAYMENT,
  });
  try {
    res = await axios.post(BHAREE_BASE_URL_LOCAL + "/orders", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    });
    const mPayload = {
      ...res.data.data,
      success: res.data.success,
      message: res.data.message,
    };

    return res.status === 200
      ? dispatch({
          type: appConstants.GET_PAYMENT,
          payload: mPayload,
        })
      : "";
  } catch (err) {
    dispatch({
      type: appConstants.ERRORS_PAYMENT,
      payload: err.response,
    });
    return toast.error(
      err.hasOwnProperty("response")
        ? err?.response?.data?.message
        : `sever not responding at orders`,
    );
  }
};

export const postCalculations = (data, dispatch) => {
  dispatch({
    type: appConstants.LOADING_CALCULATION_FILE,
  });
  axios
    .post(BHAREE_BASE_URL_LOCAL + "/api/getcostcalculation", data, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      dispatch({
        type: appConstants.GET_CALCULATION_FILE,
        payload: res.data.data,
      });
      const pdfUrl = res.data.data; // Replace with your PDF URL
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("target", "_blank");
      link.setAttribute("download", "calculation.pdf"); // Specify the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.ERRORS_CALCULATION_FILE,
        payload: err,
      });
      return err;
    });
};

export const postGetGSTPrice = async (data, dispatch) => {
  await dispatch({
    type: appConstants.REQUEST_CALL,
  });
  let res = {};
  if (!isEmpty(data.price)) {
    try {
      res = await axios.post(
        BHAREE_BASE_URL_LOCAL + "/api/getCalculatedGSTPrice",
        { price: data.price },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken} `,
          },
        },
      );
      if (res.status === 200) {
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
          payload: res,
        });
        return res;
      }
    } catch (err) {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err,
      });
      return err;
    }
  }
};

export const postGetCalculatedprice = async (data, dispatch) => {
  await dispatch({
    type: appConstants.LOADING_CALCULATED_PRICE,
  });
  let res = {};
  if (!isEmpty(data.price)) {
    try {
      res = await axios.post(
        BHAREE_BASE_URL_LOCAL + "/api/getcalculatedprice",
        { price: data.price },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken} `,
          },
        },
      );
      if (res.status === 200) {
        let obj = {};
        obj[data.variantId] = res.data.data;
        return dispatch({
          type: appConstants.GET_CALCULATED_PRICE,
          payload: obj,
        });
      }
    } catch (err) {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.ERRORS_CALCULATED_PRICE,
        payload: err,
      });
      return err;
    }
  }
  // axios
  //   .post(BHAREE_BASE_URL_LOCAL + "/api/getcostcalculation", data, {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": "*",
  //       Authorization: `Bearer ${localStorage.jwtToken} `,
  //     },
  //   })
  //   .then((res) => {
  //     toast.success(res.data.message);
  //     dispatch({
  //       type: appConstants.GET_CALCULATED_PRICE,
  //       payload: res.data.data,
  //     });
  //     const pdfUrl = BHAREE_BASE_URL_LOCAL + res.data.data; // Replace with your PDF URL
  //     const link = document.createElement("a");
  //     link.href = pdfUrl;
  //     link.setAttribute("target", "_blank");
  //     link.setAttribute("download", "calculation.pdf"); // Specify the file name
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   })
  //   .catch((err) => {
  //     toast.error(err.response.data.message);
  //     dispatch({
  //       type: appConstants.ERRORS_CALCULATED_PRICE,
  //       payload: err,
  //     });
  //     return err;
  //   })
};
// export const postGetCalculatedpriceD = async (data) => {
//   let res = {}
//   if (!isEmpty(data)) {
//     try {
//       res = await axios.post(BHAREE_BASE_URL_LOCAL + "/getcostcalculation", { price: data }, {
//         headers: {
//           "Content-Type": "application/json",
//           "Access-Control-Allow-Origin": "*",
//           Authorization: `Bearer ${localStorage.jwtToken} `,
//         },
//       })
//       if (res.status === 200) {
//         return res.data.data
//       }else {
//         return 0
//       }
//     } catch (err) {
//       toast.error(err.response.data.message);
//       return 0
//     }
//   }
// };

// update api

export const updateUserStatus = (userId, dispatch, roleType) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .get(BHAREE_BASE_URL_LOCAL + `/admin/updateUserStatus/${userId}`, options)
    .then((res) => {
      toast.success(res.data.message);
      if (roleType === "seller") {
        getApi("getUserListSeller", dispatch);
      } else if (roleType === "buyer") {
        getApi("getUserListBuyer", dispatch);
      } else if (roleType === "employee") {
        getApi("getUserListEmployee", dispatch);
      } else if (roleType === "logistic_partner") {
        getApi("getUserListLogisticPartner", dispatch);
      } else {
        getApi("getUserList", dispatch);
      }
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const patchBrand = (brandtId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/brands/${brandtId}`, userData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getBrands", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

export const patchProduct = (brandtId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/products/${brandtId}`, userData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getProducts", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const patchAddress = (addressId, address, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/users/updateAddress/${addressId}`, address, options)
    .then((res) => {
      toast.success(res.data.message);
      getApi("getAddressess", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const patchCompanyInfo = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + "/users/companyInfo", userData, {
      headers: {
        // "Content-Type": "application/json",
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getCompanyInfo", dispatch);
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      dispatch({
        type: appConstants.REQUEST_FAIL,
        payload: err.response.data,
      });
    });
};

export const patchProductVariant = (variantId, userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + "/products/variants", userData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getProducts", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const patchLiveOffer = (userData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/liveoffers/${userData.id}`, userData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getLiveOffer", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

export const patchCart = (cartData, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/cart/${cartData.id}`, cartData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getCart", dispatch);
      return res.data;
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

/// patch enquiry
export const patchEnquiry = (data, dispatch) => {
  dispatch({
    type: appConstants.REQUEST_CALL,
  });
  axios
    .patch(BHAREE_BASE_URL_LOCAL + `/enquiry/updateEnquiryStatus/${data.id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${localStorage.jwtToken} `,
      },
    })
    .then((res) => {
      toast.success(res.data.message);
      getApi("getEnquiry", dispatch);
      dispatch({
        type: stringConstants.SET_CURRENT_VIEW,
        payload: stringConstants.MY_ENQUIRIES,
      });
    })
    .catch((err) => {
      toast.error(err.response.data.message);
      return err;
    })
    .finally(() => {
      dispatch({
        type: appConstants.REQUEST_COMPLETED,
      });
    });
};

/// patch Order
export const patchOrder = async (data, dispatch, dispatchObj) => {
  try {
    dispatch({ type: appConstants.REQUEST_CALL });

    const res = await axios.patch(
      `${BHAREE_BASE_URL_LOCAL}/orders/updateOrderStatus/${data.id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      },
    );

    toast.success(res.data.message);
    await getApi("getOrders", dispatch);

    if (!isEmpty(dispatchObj)) {
      dispatch(dispatchObj);
    } else {
      dispatch({
        type: stringConstants.SET_CURRENT_VIEW,
        payload: stringConstants.MY_ORDERS,
      });
    }

    return res.data; // ✅ return response so caller can handle it
  } catch (err) {
    toast.error(err?.response?.data?.message || "Something went wrong");
    return Promise.reject(err); // ✅ propagate error to caller
  } finally {
    dispatch({ type: appConstants.REQUEST_COMPLETED });
  }
};

// delete api
export const deleteVariant = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/variants/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};

export const deleteMoq = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/moqs/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
        // dispatch({
        //   type: appConstants.GET_BHAREE_ADMIN_BASIC_TABLE,
        //   payload: res.data.data,
        // });
        // set current user data
      })
      .catch(
        (err) => {
          return err;
        },
        // dispatch({
        //   type: appConstants.ERRORS_BHAREE_ADMIN_BASIC_TABLE,
        //   payload: err.response,
        // })
      );
  }
};

export const deleteProductCategories = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/productcategory/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
        // dispatch({
        //   type: appConstants.GET_BHAREE_ADMIN_BASIC_TABLE,
        //   payload: res.data.data,
        // });
        // set current user data
      })
      .catch(
        (err) => {
          return err;
        },
        // dispatch({
        //   type: appConstants.ERRORS_BHAREE_ADMIN_BASIC_TABLE,
        //   payload: err.response,
        // })
      );
  }
};
export const deletePackagingTypes = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/packagingtype/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};
export const deleteDeliveryType = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/deliverytype/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};
export const deletePaymentTypes = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/paymenttype/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};
export const deleteShelfLife = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/shelflife/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBhreeAdminBasicTables", dispatch);
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  }
};

export const deleteBrand = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/brands/${variantId} `, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getBrands", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      })
      .finally(() => {
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });
      });
  }
};

export const deleteProduct = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/products/${variantId}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getProducts", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      })
      .finally(() => {
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });
      });
  }
};

export const deleteAddress = async (address, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/users/deleteAddress/${address.id}`, options)
      .then((res) => {
        if (res.success) {
          toast.success(res.data.message);
          getApi("getAddressess", dispatch);
        } else {
          toast.error(res.data.message);
        }
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      })
      .finally(() => {
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });
      });
  }
};

export const deleteCartItem = async (address, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/cart/${address.id} `, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.jwtToken} `,
        },
      })
      .then((res) => {
        toast.success(res.data.message);
        getApi("getCart", dispatch);
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });

        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};

export const deleteLiveOffer = async (id, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/liveoffers/${id}`, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getLiveOffer", dispatch);
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });

        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      });
  }
};

export const deleteProductVariant = async (variantId, dispatch, confirm) => {
  const isConfirmed = await confirm("Are you sure you want to delete?", "");
  if (isConfirmed) {
    dispatch({
      type: appConstants.REQUEST_CALL,
    });
    axios
      .delete(BHAREE_BASE_URL_LOCAL + `/products/variants/${variantId} `, options)
      .then((res) => {
        toast.success(res.data.message);
        getApi("getProducts", dispatch);
        return res.data;
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        return err;
      })
      .finally(() => {
        dispatch({
          type: appConstants.REQUEST_COMPLETED,
        });
      });
  }
};
